module.exports = "/_next/static/files/b86a0a330f56d1ee35986124be5d59bd.png";